<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px">
        <v-row>
          <v-col cols="12" class="pa-8">
            <v-btn 
              :to="{ name: 'newActivityProgramEdition', params: { edition_id: this.edition_id, program_id: this.program_id } }"
              color="primary">
              Nueva Actividad
            </v-btn>
          </v-col>

          <v-col cols="12" class="pa-8" v-if="!loading">
            <h2 class="text-center text--secondary font-weight-regular">
              {{ (program.name)? program.name+': '+convertDate(program.date):convertDate(program.date) }}
            </h2>
          </v-col>

          <v-col cols="12">
            <v-data-table
              v-if="!loading"
              class="pt-8"
              :headers="headers"
              :items="activities"
              :custom-filter="customSearch"
              :items-per-page="30"
              :header-props="headerProps"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100],
                'items-per-page-text':'Actividades por página',
              }"
              mobile="true"
            >
            <template v-slot:item.start_time="{ item }">
              {{ item.hour }}
            </template>
              <template v-slot:item.actions="{ item }">
                <td class="text-center">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="primary"
                    :to="{ name: 'showActivityProgramEdition', params: {edition_id: edition_id, activity_id: item.id } }"

                  >
                    <v-icon dark small>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="warning"
                    :to="{ name: 'editActivityProgramEdition', params: {edition_id: edition_id, program_id: program_id, activity_id: item.id } }"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    @click="confirmDeleteActivity(item.id)"
                  >
                    <v-icon dark small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>
   
    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'programEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        color="primary"
        :to="{ name: 'showAllActivityProgramEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-eye
        </v-icon>
        Vista previa
      </v-btn>
    </v-col>

    <v-dialog
      v-model="dialog_delete"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          ¿Está seguro que desea borrar a esta actividad? Toda la información
          vinculada a ella se borrara tambíen.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_delete = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="loading_btn"
            @click="deleteActivity()"
          >
            Borrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'activitiesProgramEdition',

    data: () => ({
      loading:true,
      loading_btn:false,
      dialog_delete: false,
      delete_id:null,

      edition_id:null,
      program_id:null,

      activities:[],
      program:[],

      headerProps: {
        sortByText: "Ordenar por"
      },
      headers: [
        {
          text: 'Horario',
          align: 'center',
          sortable: true,
          value: 'start_time',
          width: '15%'
        },
        {
          text: 'Tipo de Actividad',
          align: 'center',
          sortable: true,
          value: 'type_of_activity_name',
          width: '20%'
        },
        {
          text: 'Actividad',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '40%'
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '20%'
        }
      ],
      attrs: {
        boilerplate: false,
      },
    }),

    methods:{
      customSearch (value, search, item) {
          return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search))
      },
      
      filterOnlyCapsText (value, search, item) {
        console.log(item)
        return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
      },

      calculateTime(start_time, finish_time) {
        // Obtener las horas y minutos de las variables de tiempo
        const [startHour, startMinute] = start_time.split(':').map(Number);
        const [finishHour, finishMinute] = finish_time.split(':').map(Number);

        // Determinar si es AM o PM
        const startPeriod = startHour < 12 ? 'am' : 'pm';
        const finishPeriod = finishHour < 12 ? 'am' : 'pm';

        // Convertir las horas a formato de 12 horas
        const formattedStartHour = startHour % 12 || 12;
        const formattedFinishHour = finishHour % 12 || 12;

        // Generar el resultado en el formato deseado
        const startTimeString = `${formattedStartHour}:${startMinute < 10 ? '0' : ''}${startMinute} ${startPeriod}`;
        const finishTimeString = `${formattedFinishHour}:${finishMinute < 10 ? '0' : ''}${finishMinute} ${finishPeriod}`;

        return `${startTimeString}-${finishTimeString}`;
      },

      convertDate(date) {
        const parts = date.split('-');
        const day = parts[2];
        const month = parts[1];
        const year = parts[0];

        return `${day}/${month}/${year}`;
      },

      async getActivitiesEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/program-edition/'+this.program_id+'/activities').then(response =>{
          this.activities = response.data.data.activities
          this.program = response.data.data.program

          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      },

      confirmDeleteActivity(id)
      {
        this.dialog_delete = true
        this.delete_id = id
      },

      async deleteActivity()
      {
        this.loading_btn = true
        try {  
          await axios.delete('admin/editions/'+this.edition_id+'/activities/'+this.delete_id).then(() =>{
            this.dialog_delete = false
            this.loading_btn =false
            this.delete_id = null
            this.getActivitiesEdition()
          })
        } catch (error) {
          console.error(error.response.data);
        }
      },
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.program_id = this.$route.params.program_id
      this.getActivitiesEdition()
    },
  }
</script>
